/* jshint bitwise:false */
'use strict';

function getLuminance(color) {
  /* jshint bitwise:false */
  var c = parseInt(color, 16),
      r = (c & 0xFF0000) >> 16,
      g = (c & 0x00FF00) >> 8,
      b = (c & 0x0000FF);

  return (0.299*r + 0.587*g + 0.114*b);
}

var BackColorMixin = {
  getTextColor: function (backColor) {
    var lum = getLuminance(backColor);
    return lum > 160 ? 'dark' : 'light';
  },

  parseColor: function (color) {
    if (color[0] === '#') {
      color = color.slice(1);
    }

    var rgb;
    if ((rgb = /^([\da-fA-F]{2})([\da-fA-F]{2})([\da-fA-F]{2})/.exec(color) || []).length) {
      rgb = [parseInt(rgb[1], 16), parseInt(rgb[2], 16), parseInt(rgb[3], 16)];
    } else {
      throw new Error(color + ' is not in RRGGBB format.');
    }

    return rgb;
  }
};

module.exports = BackColorMixin;



/** WEBPACK FOOTER **
 ** ./mixins/BackColorMixin.js
 **/